import { useToast } from 'Store/toast';
import useIsMobile from 'Hook/useIsMobile';

const useCopyToClipboard = () => {
  const { onOpenToast } = useToast();
  const isMobile = useIsMobile();

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    const toastType = isMobile ? 'mobile' : 'desktop';
    onOpenToast({
      status: 'success',
      type: toastType,
      description: label ? `${label} berhasil disalin.` : 'Berhasil disalin.',
      duration: 5,
      position: toastType === 'mobile' ? 'top-mobile' : 'top',
    });
  };

  return { copyToClipboard };
};

export default useCopyToClipboard;
